module.exports = __webpack_public_path__ + "static/media/head-shot.c4aea060.jpg";